import type { FormService } from './formService';

export class StateService {
  public showErrors: boolean = false;
  public loadedSavedData: boolean = false;
  public showForm: boolean = true;
  public formSubmitted: boolean = false;
  public submitErrorMsg: string = '';

  public canProceedToNextStep(_formService: FormService): boolean {
    return true;
  }
}
